/**
 * The credential re-check field and its failure words (plan
 * docs/plans/lms-plan.md 7.3, R20; 18.22; WP-45). A competency sign-off
 * (Team, Sign-offs) and an external-certificate review (Team, External
 * certificates) are signed with the admin's own password, checked on the
 * server; a wrong one answers 401 LMS_REAUTH_FAILED and records nothing but
 * the audit row. The password lives only in the dialog's state: it is posted
 * once (api/team.ts passes { _retry: true }), cleared after a failure and
 * when the dialog closes, and never logged or shown.
 */
import { fieldCls } from '../../../../ui/styles';
import { apiErrorCode, apiErrorMessage } from '../../../api/client';
import { labelCls, metaCls } from '../../../components/pickers/shared';

/** The words for a failed signing request: the re-check's own message, or the server's. */
export function signingErrorText(err: unknown, fallback: string): string {
  if (apiErrorCode(err) === 'LMS_REAUTH_FAILED') {
    return "That password did not match your account. Nothing was recorded; enter your password again.";
  }
  return apiErrorMessage(err, fallback);
}

export interface PasswordFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  testId?: string;
}

export function PasswordField({ id, value, onChange, disabled, testId }: PasswordFieldProps) {
  return (
    <div>
      <label className={labelCls} htmlFor={id}>
        Your password
      </label>
      <input
        id={id}
        type="password"
        autoComplete="current-password"
        className={`${fieldCls} w-full sm:w-72`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        data-testid={testId}
      />
      <p className={metaCls}>Signing needs your password again (21 CFR Part 11). It is checked once and never stored.</p>
    </div>
  );
}

export default PasswordField;
